<template>
    <div class="">
        <el-button size="small" v-permission="'User:Code'" @click="showQr" style="margin-left: 10px;">报警二维码</el-button>
        <el-dialog title="报警二维码" :visible.sync="centerDialogVisible" width="30%" :append-to-body="true">
            <el-form label-position="top" :model="Qrfrom" :rules="rules1" ref="ruleForm1">
                <el-form-item label="请输入名称" prop="T_name">
                    <el-input v-model="Qrfrom.T_name"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="centerDialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="submitForms('ruleForm1')">确 定</el-button>
            </span>
            <el-dialog :visible.sync="centerDialogVisibleEr" width="700px" :append-to-body="true"
                :close-on-click-modal='false' :close-on-press-escape='false'>
                <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                    <h2><span style="color: #02bd5c;">[{{ Qrfrom.T_name }}]</span>-使用微信扫一扫</h2>
                    <el-image style="width: 250px; height: 250px" :src="qrUrl" :preview-src-list="srcList">
                    </el-image>
                    <div style="font-size: 16px;padding-top: 10px;transform: scale(.8);display: flex;">
                        <div>注：</div>
                        <div>
                            <p style="margin-bottom: 10px;">1.只允许【张三】一个人扫码，不能多人共扫一个二维码，多人请一个一个的添加绑定</p>
                            <p style="margin-bottom: 10px;">2.使用微信扫码，并关注微信公众号</p>
                            <p style="margin-bottom: 10px;">3.已关注微信公众号，点击我已关注完成绑定</p>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </el-dialog> 
    </div>
</template>

<script>
import { UserWxQRCode } from '@/api/systemManagement/personal.js'
export default {
    name: "",
    props: {
        row: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            centerDialogVisible: false,
            centerDialogVisibleEr: false,
            Qrfrom: {
                T_name: '',
                T_uuid: this.row.T_uuid
            },
            rules1: {
                T_name: [{ required: true, message: '请输入名称', trigger: 'blur' }]
            },
            qrUrl: '',
            srcList: []
        }
    },
    mounted() {

    },
    methods: {
        showQr() {
            this.centerDialogVisible = true;
            this.Qrfrom.T_name = this.row.T_name
        },
        submitForms(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.centerDialogVisible = false;
                    //调取二维码
                    this.GeQRApi()
                } else {
                    console.log('校验失败');
                    return false;
                }
            });
        },
        GeQRApi() {
            return new Promise(resolve => {
                UserWxQRCode(this.Qrfrom).then(res => {
                    this.qrUrl = res.data.Data
                    this.srcList.push(res.data.Data)
                    this.centerDialogVisibleEr = true
                    this.centerDialogVisible = false
                    resolve(res)
                })
            })
        },
    }
}
</script>
<style lang="scss">
/* @import url(); 引入css类 */
</style>